import * as types from '../constants/actionsTypes';
import API from '../api';
import commonAction from './commonAction';
import NewApi from '../apiClient/HttpClient/NewApi';

const api = new API();

export const loadInitData = (cb) => {
	return dispatch => {
		dispatch({
			type: types.INIT_DATA_REQUEST
		})

		NewApi.post('/api/v1/user/environment')
			.toPromise()
			.then(
				(response) => {
					dispatch({
						type: types.INIT_DATA_SUCCESS,
						initData: response.data
					});
					if (cb) { cb(); }
				},
				(response) => {
					dispatch({
						type: types.INIT_DATA_FAILURE,
						error: response.error
					});
				}
			);
	}
}

/**
 * Колбек на отправку формы авторизации
 * @param {Object.<String>} data Данные формы
 */
export const submitLoginForm = (data, cb) => {
	return dispatch => {
		api.post('/login', data)
			.then(response => {
				if (!response.success) {
					dispatch({
						type: types.LOGIN_FAILURE,
						error: response.data
					});

					return;
				}

				const token = response.data.accessToken;
				localStorage.setItem('AuthToken', token);
				dispatch(loadInitData(() => {
					dispatch({
						type: types.LOGIN_SUCCESS,
						authToken: token
					});
					if (cb) {
						cb();
					}
				}));
			}, response => {
				dispatch({
					type: types.LOGIN_FAILURE,
					error: response.error
				});
			});
	}
}

/**
 * Метод для сброса авторизации
 * @param {func} cb
 */
export const logout = (cb) => {
	return dispatch => {
		api.post('/logout')
			.then(response => {
				if (!response.success) {
					dispatch({
						type: types.LOGOUT_FAILURE,
						error: response.error
					});

					return;
				}

				dispatch({
					type: types.LOGOUT_SUCCESS
				});
				localStorage.removeItem('AuthToken');
				if (cb) {
					cb()
				}
			});
	}
}

/**
 * Метод сброса ошибки сервера
 */
export const clearErrors = () => {
	return {
		type: types.LOGIN_ERRORS_CLEAR
	}
}

/**
 * Выход при ошибке авторизации
 */
export const authorizationError = () => {
	localStorage.removeItem('AuthToken');
	return {
		type: types.LOGOUT_SUCCESS
	}
}



// WEBPACK FOOTER //
// ./actions/webInterface.js